const groupBy = <T>(array: T[], predicate: (value: T, index: number, array: T[]) => string) =>
  array.reduce(
    (acc, value, index, arr) => {
      // eslint-disable-next-line immutable/no-mutation
      (acc[predicate(value, index, arr)] ||= []).push(value);
      return acc;
    },
    {} as { [key: string]: T[] },
  );

export default groupBy;
